import styled from 'styled-components';

export const MarginBottom = styled.div`
	margin-bottom: 0px;
`;

export const CardContent = styled.div`
	padding: 3px 10px;
`;
